import type { InvoiceTemplate } from '@/pages/sidebar/SettingsPage/types';

export interface InvoiceTemplateWithRef extends InvoiceTemplate {
  templateRef: string;
}

export const DEFAULT_INVOICE_TEMPLATES: InvoiceTemplateWithRef[] = [];
